import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[limitTextarea]'
})
export class LimitTextAreaDirective {
  private textArea: HTMLTextAreaElement;

  constructor(private el: ElementRef) {
    this.textArea = this.el.nativeElement;
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    // Remove all newline characters
    this.textArea.value = this.textArea.value.replace(/\n/g, '');
  }
}
